import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import AutoAwesomeRounded from "@mui/icons-material/AutoAwesomeRounded";
import { Fab, Tooltip } from "@mui/material";

/** Размер и отступы как у кнопки помощника зрителя на витрине (AssistantBubble). */
const FAB_SIZE = 60;
const FAB_OFFSET = 16;

/** Нижний отступ страницы, чтобы её последняя строка не пряталась под кнопкой. */
export const ASSISTANT_FAB_CLEARANCE = FAB_SIZE + FAB_OFFSET * 2;

export interface AssistantFabProps {
  expanded: boolean;
  controlsId: string;
  onClick: () => void;
}

/**
 * Круглая кнопка помощника в правом нижнем углу. Слой ниже шапки, ящика
 * меню и любых диалогов кабинета: она не перекрывает их кнопки.
 */
export const AssistantFab = forwardRef<HTMLButtonElement, AssistantFabProps>(
  ({ expanded, controlsId, onClick }, ref) => {
    const { t } = useTranslation();
    const label = t("partnerAssistant.open");
    return (
      <Tooltip title={label} placement="left">
        <Fab
          ref={ref}
          color="primary"
          aria-label={label}
          aria-expanded={expanded}
          aria-controls={controlsId}
          onClick={onClick}
          sx={({ transitions, shadows, zIndex }) => ({
            position: "fixed",
            right: FAB_OFFSET,
            bottom: FAB_OFFSET,
            zIndex: zIndex.speedDial,
            width: FAB_SIZE,
            height: FAB_SIZE,
            transition: transitions.create(["transform", "box-shadow"], {
              duration: transitions.duration.shorter,
            }),
            "&:hover": {
              transform: "scale(1.07)",
              boxShadow: shadows[10],
            },
            "&:focus-visible": {
              outline: "2px solid",
              outlineColor: "primary.main",
              outlineOffset: 2,
            },
          })}
        >
          <AutoAwesomeRounded sx={{ fontSize: 28 }} />
        </Fab>
      </Tooltip>
    );
  }
);
AssistantFab.displayName = "AssistantFab";
